import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import env from "./env/env.json";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

Sentry.init({
  dsn: "https://eabe75c85444269329026dcb92c087e1@o4509116679520256.ingest.de.sentry.io/4509116681945168",
});

const x_id_submit =
  Date.now() + "SUBMIT" + (Math.floor(Math.random() * 99999) + 10000);
const TypeForm = "CUCP";
const root = ReactDOM.createRoot(document.getElementById("root"));
console.log(
  "CUCP - " + env.ville + " - " + env.environnement + " : V" + env.version
);

root.render(
  <React.StrictMode>
    <App x_id_submit={x_id_submit} TypeForm={TypeForm} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
